import { CourseVersionsResponse } from '../Types/CourseVersionsResponse';
import { IDirectAccessReducer } from '../Interfaces/IDirectAccessReducer';
import { DirectAccessCourseResponse } from '../Types/DirectAccessCourseResponse';

export const courseVersionsInitState: CourseVersionsResponse = {
  data: [],
  metadata: {},
};

export const courseDetailsInitState: DirectAccessCourseResponse = {
  data: {
    version: '',
    modules: [],
    id: '',
    product: {
      id: '',
      name: '',
    },
    hasRepositories: true,
  },
  metadata: {},
};

export const directAccessInitState: IDirectAccessReducer = {
  courseVersions: courseVersionsInitState,
  courseDetails: courseDetailsInitState,
};
